// src/components/NotFound.js
import React from 'react';

import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
            <h1>404</h1>
            <h3>Oops! The page you're looking for doesn't exist.</h3>
            <p>
                <Link to="/" style={{ color: '#3382b0', textDecoration: 'underline' }}>
                    Go back to Home
                </Link>
            </p>
        </div>
    );
};

export default NotFound;
